import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';

const Brochure = (props) => {
    return (
        <div className='brochure detail__specs-service-logs'>
            <h3 className='detail__specs-heading'><TranslationText tKey='sandhills.brochure' /></h3>
            <div className='detail__specs-wrapper'>
                <div className='detail__specs-label'>
                    {props.Brochure.Type}
                </div>
                <div className='detail__specs-value'>
                    {props.Brochure.Files && props.Brochure.Files.length > 0 && props.Brochure.Files.map(brochure =>
                        <a className='detail__specs-link' target='_blank' content="noindex" href={brochure.Url} aria-label={brochure.Name + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>{brochure.Name}</a>)}
                </div>
            </div>
        </div>
    );
};

export default Brochure;